module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "appSign"
    }
  }, [_c('com-loading'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./../assets/icon.png"),
      "alt": "icon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "signInGroup",
    on: {
      "click": _vm.handleGoogleSignIn
    }
  }, [_c('span', {
    staticClass: "signInTitle"
  }, [_vm._v("Google 登入/註冊")])]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "alert",
      "alertType": "fail",
      "modalId": "signAlertModal",
      "title": _vm.alertMsg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df2322f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-sign.vue
// module id = 194
// module chunks = 2